module.exports = __webpack_public_path__ + "static/img/playIcon.6cdc38c0.png";